var map = {
	"./antigua-and-barbuda.png": 35,
	"./austria.png": 36,
	"./brazil.png": 37,
	"./canada.png": 38,
	"./colombia.png": 39,
	"./cuba.png": 40,
	"./england.png": 41,
	"./estonia.png": 42,
	"./finland.png": 43,
	"./france.png": 44,
	"./ireland.png": 45,
	"./italy.png": 46,
	"./lithuania.png": 47,
	"./maldives.png": 48,
	"./montenegro.png": 49,
	"./san-marino.png": 50,
	"./scotland.png": 51,
	"./slovenia.png": 52,
	"./spain.png": 53,
	"./switzerland.png": 54,
	"./usa.png": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;